export default "__VITE_ASSET__C$rfFdDt__"